// extracted by mini-css-extract-plugin
export default {"pattern":"styles_pattern__yXf1a","content":"styles_content__jhS4E"};